












































import { computed, defineComponent } from '@vue/composition-api';

import store from '@/store';

export default defineComponent({
  name: 'UserSettingsMenu',
  setup(props, ctx) {
    const user = computed(() => store.state.client?.user);
    const username = computed(() => user.value?.username || '—');
    const email = computed(() => user.value?.email || 'Not set');
    const userGroup = computed(() => user.value?.user_group || '—');
    const institution = computed(() => user.value?.institution || '—');

    function changeEmail() {
      ctx.emit('close');
      ctx.root.$router.push({ path: '/email-verification', query: { changeEmail: '1' } });
    }

    return {
      changeEmail,
      email,
      institution,
      userGroup,
      username,
    };
  },
});
